const PageHeader = ({ title, description, children, classes, header }) => {
  return (
    <section className="bg-neutral-100 dark:bg-neutral-800">
      <article className={"!py-20 c-container " + classes}>
        {header}
        <h1 className="text-4xl font-semibold">{title}</h1>
        {(description || children) && (
          <div className="mt-6">{children || description}</div>
        )}
      </article>
    </section>
  );
};

export default PageHeader;
